import MarketStore from '@components/LocalMerchant/MarketingCenter/Market/store'
import { PRODUCT_STANDARD_PRO, SUCCESSFULLY_OPENED_PATH } from '@constant'
import {
  isFlowerDessert,
  isHonorable,
  isPureUltimate,
  isSiDaProperty,
  isStandard
} from '@merchant-backend/util'
import {
  buyUltimate,
  buyZunXiang,
  getShopProductData,
  goPayment,
  HLJ_STATISTIC,
  isSiDaMember,
  isSiDaTeam,
  isTelSaleCityMerchant
} from '@util'
import { Button } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import moment from 'moment'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import style from './index.module.less'
import Modal from './modal'

@observer
class Index extends Component {
  gotoDetial = () => {
    MarketStore.initialTab = '3'
    hashHistory.push('localMerchant/marketingCenter/market')
  }

  handleUpgrade = () => {
    if (isTelSaleCityMerchant()) {
      buyZunXiang()
      return
    }
    const { store } = this.props
    const purchaseData = toJS(store.purchaseData)
    if (
      purchaseData.flagship.is_buy_flagship == 0 ||
      purchaseData.standard_to_flagship.is_buy_standard_to_flagship == 0
    ) {
      store.setStoreData('showModal', true)
      return
    }
    goPayment({
      fee: purchaseData.flagship.fee,
      product_id: PRODUCT_STANDARD_PRO
    })
  }

  getButtonArea = (detail, coupon, flagship_price) => {
    const _isStandard = isStandard()
    const _isUltimate = isPureUltimate()
    const _isZunXiang = isHonorable()
    const { coupon_type, gift_day, money_value, rest_day } = coupon

    let dateKey = _isStandard
      ? 'ser_date'
      : _isUltimate
        ? 'pro_date'
        : 'enjoy_date'

    const UltimateCoupon = coupon_type ? (
      coupon_type == 2 ? (
        <span>
          您已有一张限时延时券，续费多送{gift_day}天 ，还剩{rest_day}天过期
        </span>
      ) : (
        <span>
          您已有一张限时优惠券，续费即减￥{money_value} ，还剩{rest_day}天过期
        </span>
      )
    ) : null

    if (
      (_isStandard || _isUltimate || _isZunXiang) &&
      isTelSaleCityMerchant()
    ) {
      return (
        <>
          <Button
            type="primary"
            onClick={() => {
              buyZunXiang()
            }}
          >
            立即{_isZunXiang ? '续费' : '升级'}
          </Button>
          <span>已开通 有效期至{detail[dateKey]}</span>
          {_isUltimate && UltimateCoupon}
        </>
      )
    }

    if (_isStandard) {
      return null
    }
    if (isFlowerDessert()) {
      return (
        <>
          <Button
            type="primary"
            onClick={() => {
              buyUltimate()
            }}
          >
            立即咨询
          </Button>
          <span>已开通 有效期至{detail[dateKey]}</span>
          {UltimateCoupon}
        </>
      )
    }
    if (_isUltimate) {
      return (
        <>
          <Button
            type="primary"
            onClick={() => {
              HLJ_STATISTIC({
                element_tag: 'renew_pro'
              })
              let params = {
                // todo，旗舰版应不需要传价格到支付页，暂时先处理四大的
                fee: isSiDaProperty() ? undefined : flagship_price.fee
              }
              params = this.getBase64Params(params)
              goPayment(params)
            }}
          >
            立即续费
          </Button>
          <span>已开通 有效期至{detail[dateKey]}</span>
          {UltimateCoupon}
        </>
      )
    }

    return null
  }

  // base64 加密文件
  // 计算过期时间，当前过期时间 + 1 year
  getBase64Params = params => {
    const { detail } = this.props
    const proDate = moment(
      detail['pro_date'] ||
        detail['enjoy_date'] ||
        moment().format('YYYY-MM-DD'),
      'YYYY-MM-DD'
    )
      .add(1, 'y')
      .format('YYYY-MM-DD')
    let param
    if (isSiDaTeam()) {
      param = window.btoa(
        JSON.stringify({
          proDate,
          type: 'team'
        })
      )
    } else if (isSiDaMember()) {
      param = window.btoa(
        JSON.stringify({
          proDate,
          type: 'member'
        })
      )
    }
    const returnUrl = SUCCESSFULLY_OPENED_PATH + `?param=${param}`
    Object.assign(params, { return_url: returnUrl })
    return params
  }

  getContent = (detail, standard_price, flagship_price, coupon) => {
    if (isSiDaMember()) return // 四大个人，不显示头部

    const { title, des } = getShopProductData()
    const _isStandard = isStandard()
    const _isUltimate = isPureUltimate()
    const _isZunXiang = isHonorable()

    return _isStandard || _isUltimate || _isZunXiang ? (
      <div className={style.standart}>
        <img
          className={style.logo}
          src={
            _isStandard
              ? 'https://qnm.hunliji.com/o_1d56p8n67ght88it7n1drerlu9.png'
              : 'https://qnm.hunliji.com/o_1d4m9s92q1ge51ls31mcnf1a198l1e.png'
          }
        />
        <div className={style['standard-content']}>
          <div className={style.left}>
            <h2>
              {title}
              {+detail.pending_count > 0 && (
                <span className={style.morePay}>
                  还有{detail.pending_count}条店铺服务待生效，点击<span
                    onClick={() => this.gotoDetial()}
                  >
                    查看
                  </span>支付订单
                </span>
              )}
            </h2>
            <p>{des}</p>

            {_isStandard ? (
              <h3>
                标准版价格：<span>¥{standard_price.pay_fee}/年</span>
                <span>原价：¥{standard_price.fee}</span>
              </h3>
            ) : _isUltimate ? (
              !isFlowerDessert() && (
                <h3>
                  旗舰版价格：<span>¥{flagship_price.pay_fee}/年</span>
                  <span>原价：¥{flagship_price.fee}</span>
                </h3>
              )
            ) : (
              <h3>
                尊享版价格：<span>¥16800/半年</span>
              </h3>
            )}
            <div className={style['btn-wrap']}>
              {this.getButtonArea(detail, coupon, flagship_price)}
            </div>
          </div>

          {_isStandard && (
            <img
              className={style['open-logo']}
              onClick={this.handleUpgrade}
              src={
                isTelSaleCityMerchant()
                  ? '//qnm.hunliji.com/o_1dpkvh9fh1dfp19v6u3gvll11d29.png'
                  : '//qnm.hunliji.com/o_1d47buito1o26pf9165d182q1thb9.png'
              }
            />
          )}
        </div>
      </div>
    ) : null
  }

  render() {
    const { detail, pay_money, coupon, store } = this.props
    const { flagship_price = {}, standard_price = {} } = pay_money
    const { BANNER } = store.getPageConfig()
    // 非基础版，非旗舰版，非尊享版显示不同的宣传图，四大个人不显示
    const showBanner =
      !isStandard() && !isPureUltimate() && !isHonorable() && !isSiDaMember()

    return (
      <div className={style.header}>
        {showBanner && (
          <div className={style.banner}>
            <img src={BANNER} />
          </div>
        )}

        {this.getContent(detail, standard_price, flagship_price, coupon)}
        <Modal store={store} />
      </div>
    )
  }
}

export default Index
